import React from 'react';

import Card from '../Card/index';

class CardEspeciales extends React.Component {

    render(){
        
        return(
            <div className="col s12 m4">
                <div className="row">
                    <div className="col s12 m1"></div>
                    <div className={`col s10 push-s1 m10 ${this.props.push_pull}`}>
                        <Card titulo={this.props.titulo}
                              frase={this.props.frase}
                              index={this.props.index}
                              url={this.props.url}/>
                    </div>
                    <div className="col s12 m0"></div>
                </div>
            </div>
        );
    }
}

export default CardEspeciales;